import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const forwardthinkingConfig: TSPConfig = {
  key: 'forwardthinking',
  name: 'Forward Thinking',
  category: TSPCategory.CUSTOM,
  helpText:
    'Please request API credentials from your Forward Thinking representative.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'API Username',
          name: 'username',
          type: 'text',
          required: true,
        },
        {
          label: 'API Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default forwardthinkingConfig;
